// @flow

import { LIVE_CHALLENGES } from '../constants/apiTypes';
import { getLiveChallenges } from '../api/challenges';
import { sendQuery, stopChallengePolls } from './challengeListActions';

export function startLiveChallengesPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { liveChallenges } = getState();

    dispatch(
      sendQuery({
        key: LIVE_CHALLENGES,
        query: getLiveChallenges,
        queryParams: {
          embed: ['current_user_entry', 'rule_set'],
          status: 'running'
        },
        runStraightAway: force || !liveChallenges.isInitialised
      })
    );
  };
}

export function stopLiveChallengesPoll() {
  return stopChallengePolls([LIVE_CHALLENGES]);
}
